import { buildClinicConfig } from "../../clinicConfig/build.mjs";

//#region src/tenants/skylight/clinic.ts
/**
* Skylight clinic / payor maps passed into Libretto jobs.
*
* Skylight is an Arizona practice on Athena + Availity. Do not copy HHB's values
* in here: HHB is in Texas and its payors, plan names and `LEGAL`
* indigent-insurance entry do not apply. Azalea is empty because this tenant
* does not use that vendor.
*
* No payor sets `priorAuth`: Skylight has never been able to file one, and the
* global supported-payor list it used to be gated by held only HHB's Texas
* payors. Making that per-tenant keeps the behaviour and stops it reading as an
* oversight.
*
* TODO(skylight): confirm all five `availityName` values against the payer
* dropdown on Skylight's own Availity account before the first live eligibility
* run. The lookup matches Availity's option text with `exact: true`, so a value
* that is merely close still fails. HealthSpring and Arizona Complete Health are
* the likeliest to differ — HealthSpring may be listed under Cigna, and Arizona
* Complete Health under its Centene parent.
*/
const skylightClinicConfig = buildClinicConfig({
	payors: [
		{
			payor: "BCBSAZ",
			availityName: "BCBSAZ"
		},
		{
			payor: "Humana",
			availityName: "Humana"
		},
		{
			payor: "Aetna",
			availityName: "Aetna"
		},
		{
			payor: "HealthSpring",
			availityName: "HealthSpring"
		},
		{
			payor: "AZCompleteHealth",
			availityName: "Arizona Complete Health"
		},
		{ payor: "Medicare" }
	],
	athenaPayorMappings: {
		"BCBS-AZ": {
			planName: "AZ Blue (BCBS Arizona)",
			payorId: "53589",
			payor: "BCBSAZ",
			planType: void 0
		},
		HUMANA: {
			payorId: "61101",
			payor: "Humana",
			planType: void 0
		},
		"AETNA & AETNA/US HEALTHCARE": {
			payorId: "AETNA",
			payor: "Aetna",
			planType: void 0
		},
		HEALTHSPRING: {
			planName: "HealthSpring Medicare Advantage",
			payorId: "52192",
			payor: "HealthSpring",
			planType: void 0
		},
		"ARIZONA COMPLETE HEALTH": {
			payorId: "68069",
			payor: "AZCompleteHealth",
			planType: void 0
		}
	},
	azaleaPayorMappings: {},
	insuranceGroupToInfoMapping: {}
});

//#endregion
export { skylightClinicConfig };